import { render } from "./ClipPathCover.vue?vue&type=template&id=9d9a91e4&scoped=true"
const script = {}

import "./ClipPathCover.vue?vue&type=style&index=0&id=9d9a91e4&lang=scss&scoped=true"

import exportComponent from "/Users/josiahsprankle/Desktop/personal/JDS-Music-Site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d9a91e4"]])

export default __exports__